module.exports = __webpack_public_path__ + "img/add-emergency-lighting-components-to-your-system.9781008d.png";